import {Component} from '@angular/core';

@Component({
  selector: 'app-edit-price-icon',
  templateUrl: './edit-price-icon.component.html'
})
export class EditPriceIconComponent {
}
